import React, { useEffect, useState } from "react";
import { SmartFormInterFace, SmartSoftForm, SmartValid } from "soft_digi";
import { ACCESSKEY_URLS } from "../../api/AccessKeyUrls";
import { useSiteContext } from "../../contexts/SiteProvider";
import { LOADING } from "../../services/MsgService";
import { showNotification } from "../../services/notifyService";
import { post } from "../../services/smartApiService";

interface childrenProps {
  dataIn?: any,
  loadTableData: () => void
}

const CreateProject:React.FC<childrenProps> = ({dataIn, loadTableData}) => {
  const [formData, setFormData] = useState<any>({});
    const { setLoading, closeModal} = useSiteContext();
  useEffect(()=>{   
  },[])

  
  const validations = {
    server_name: [
      SmartValid.required("Required"),    
    ],
    server_url:[
      SmartValid.required("Required"),    
    ]
  };

  const formElements:SmartFormInterFace.SmartFormElementProps[] = [
    {
      type: "TEXT_BOX",
      width: "6",
      name: "server_name",
      element: {      
        label: "Server Name",
        placeHolder: "Ex: Server-1",
        isRequired:true,
        validations: validations.server_name,
        leftIcon: "fa-briefcase"        
      },
    },

    {
      type: "TEXT_BOX",
      width: "6",
      name: "server_url",
      element: {      
        label: "Server URL / IP Address",
        placeHolder: "Ex: http://server1.com",
        isRequired:true,
        validations: validations.server_url,
        leftIcon: "fa-briefcase",       
      },
    },
    {
      type: "BUTTON",
      width: "12",
      name:"",
      class_name: "has-text-right",
      element: {
        label: "Generate",
        classList: ["smart-action-button"],
        onClick: handleSave,
      },
    },
  ];

  const handleInputChange = (name: string, value: string) => {   
    setFormData((prev:any) => ({ ...prev, [name]: value }));
  };

  function handleSave () {
    if(formData?.server_name == "") return showNotification("error","Please Enter Server Name");
    setLoading(true);
   
    const api = ACCESSKEY_URLS.INSERT
    const subscription = post(api,formData,{loadingMsg:LOADING.GENERATE}).subscribe((response) => {      
      setFormData({});     
      loadTableData();
      closeModal();
    });
    return () => {
      subscription.unsubscribe();
  };
  };
  return (
    <div className="sd-pdf-form">  
      <SmartSoftForm
        formData={formData}
        setFormData={handleInputChange}
        elements={formElements}
      />
    </div>
  );
}

export default CreateProject;
